var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import '../styles/settingWithPopup.scss';
import globalStore from '../store';
import { t } from 'i18next';
import CollapsibleDiv from './CollapsibleDiv';
import customEventHandler from '../helper/customEvents';
import { announce } from '../helper/announcer';
var isFullScreenSupported = function () {
    if (typeof document === 'undefined')
        return false;
    var el = document.documentElement;
    return !!(el.requestFullscreen || el.webkitRequestFullscreen);
};
var getFullScreenElement = function () {
    var _a, _b;
    var d = document;
    return (_b = (_a = d.fullscreenElement) !== null && _a !== void 0 ? _a : d.webkitFullscreenElement) !== null && _b !== void 0 ? _b : null;
};
var enterFullScreen = function () {
    var el = document.documentElement;
    if (el.requestFullscreen)
        return el.requestFullscreen();
    if (el.webkitRequestFullscreen)
        return el.webkitRequestFullscreen();
    return Promise.reject(new Error('not supported'));
};
var exitFullScreen = function () {
    var d = document;
    if (d.exitFullscreen)
        return d.exitFullscreen();
    if (d.webkitExitFullscreen)
        return d.webkitExitFullscreen();
    return Promise.reject(new Error('not supported'));
};
var SettingWithPopup = function (props) {
    var _a = useState(false), show = _a[0], setShow = _a[1];
    var btnRef = useRef(null);
    var _b = useState({ left: 0, bottom: 0 }), pos = _b[0], setPos = _b[1];
    var _c = globalStore.useStoreState(function (store) { return store.playerStore; }), playerIconZoom = _c.playerIconZoom, displayMode = _c.displayMode, contrast = _c.contrast, gameLoaded = _c.gameLoaded, isFullScreen = _c.isFullScreen;
    var mainConfig = globalStore.useStoreState(function (state) { return state.jsonDataStore; }).mainConfig;
    var _d = globalStore.useStoreActions(function (state) { return state.playerStore; }), setDisplayMode = _d.setDisplayMode, setContrast = _d.setContrast, setplayerIconZoom = _d.setplayerIconZoom, setIsFullScreen = _d.setIsFullScreen;
    // convert this into the transformedSettingsOptions
    // {
    //   id: item.text,
    //   title: item.text,
    //   type: 'text',
    //   imgSrc: {
    //     normal: item.icon,
    //     hover: item.icon,
    //     disable: item.icon,
    //   },
    //   color: 'white',
    //   tDirection: 'top',
    //   tDirectionFooter: 'left',
    //   activeState: false,
    //   ariaLabel: item.text,
    // }
    var settingsOptions = __spreadArray(__spreadArray([
        {
            id: 'displayMode',
            title: displayMode == 'normal' ? t('text.smartMode') : t('text.normalMode'),
            imgSrc: {
                normal: './assets/images/icons/smartBoardN.svg',
                hover: './assets/images/icons/smartBoardH.svg',
                disable: './assets/images/icons/smartBoardH.svg',
                normaldark: './assets/images/icons/smartBoardDN.svg',
                hoverdark: './assets/images/icons/smartBoardDH.svg',
                disabledark: './assets/images/icons/smartBoardDH.svg',
            },
            activeState: false,
            ariaLabel: displayMode == 'normal' ? t('text.smartMode') : t('text.normalMode'),
            color: 'white',
            // tDirection: 'right',
            tDirection: displayMode === 'normal' ? (playerIconZoom >= 1.5 ? 'topRight' : 'topRight') : 'right',
            tDirectionFooter: 'left',
            // onClick: () => setDisplayMode(displayMode == 'normal' ? 'smartBoard' : 'normal'),
        },
        // {
        //   id: 'contrast',
        //   title: contrast == 'normal' ? t('text.darkMode') : t('text.lightMode'),
        //   imgSrc: {
        //     normal: './assets/images/icons/darkModeN.svg',
        //     hover: './assets/images/icons/darkModeH.svg',
        //     disable: './assets/images/icons/darkModeH.svg',
        //     normaldark: './assets/images/icons/darkModeDN.svg',
        //     hoverdark: './assets/images/icons/darkModeDH.svg',
        //     disabledark: './assets/images/icons/darkModeDH.svg',
        //   },
        //   activeState: false,
        //   ariaLabel: contrast == 'normal' ? t('text.darkMode') : t('text.lightMode'),
        //   color: 'white',
        //   tDirection: displayMode === 'normal' ? 'top' : 'right',
        //   tDirectionFooter: 'left',
        //   // onClick: () => setContrast(contrast == 'normal' ? 'high' : 'normal'),
        // },
        {
            id: 'keyboardShortcuts',
            title: t('text.keyboardShortcuts'),
            imgSrc: {
                normal: './assets/images/icons/keyboardN.svg',
                hover: './assets/images/icons/keyboardH.svg',
                disable: './assets/images/icons/keyboardH.svg',
                normaldark: './assets/images/icons/keyboardDN.svg',
                hoverdark: './assets/images/icons/keyboardDH.svg',
                disabledark: './assets/images/icons/keyboardDH.svg',
            },
            activeState: false,
            ariaLabel: t('text.keyboardShortcuts'),
            color: 'white',
            tDirection: displayMode === 'normal' ? 'top' : 'right',
            tDirectionFooter: 'left',
            // onClick: () => {},
        }
    ], (isFullScreenSupported()
        ? [
            {
                id: 'fullScreenMode',
                title: isFullScreen ? t('text.exitFullScreenMode') : t('text.fullScreenMode'),
                imgSrc: isFullScreen
                    ? {
                        normal: './assets/images/icons/exitFullScreenN.svg',
                        hover: './assets/images/icons/exitFullScreenH.svg',
                        disable: './assets/images/icons/exitFullScreenH.svg',
                    }
                    : {
                        normal: './assets/images/icons/fullScreenN.svg',
                        hover: './assets/images/icons/fullScreenH.svg',
                        disable: './assets/images/icons/fullScreenH.svg',
                    },
                activeState: isFullScreen,
                ariaLabel: isFullScreen ? t('text.exitFullScreenMode') : t('text.fullScreenMode'),
                color: 'white',
                tDirection: (displayMode === 'normal' ? 'top' : 'right'),
                tDirectionFooter: 'left',
            },
        ]
        : []), true), [
        {
            id: 'toolAppearance',
            type: 'toggleBtn',
            // Drive the pill from the store so it shows the actual current zoom
            // (small/medium/large) on every render — not just on first mount.
            selectedValue: playerIconZoom >= 2 ? 'large' : playerIconZoom >= 1.5 ? 'medium' : 'small',
            ariaLabel: t('text.toolAppearance'),
            elements: [
                {
                    id: 'small',
                    value: 'small',
                    valueVisible: 'A',
                    title: t('text.small'),
                    ariaLabel: t('text.small'),
                },
                {
                    id: 'medium',
                    value: 'medium',
                    valueVisible: 'A',
                    title: t('text.medium'),
                    ariaLabel: t('text.medium'),
                },
                {
                    id: 'large',
                    value: 'large',
                    valueVisible: 'A',
                    title: t('text.large'),
                    ariaLabel: t('text.large'),
                },
            ],
        },
    ], false);
    var collapsibleSelectHandler = function (item, subItem) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedItem, _a, nextMode, modeName, target, _b, z;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    selectedItem = settingsOptions[item];
                    _a = selectedItem.id;
                    switch (_a) {
                        case 'displayMode': return [3 /*break*/, 1];
                        case 'contrast': return [3 /*break*/, 2];
                        case 'keyboardShortcuts': return [3 /*break*/, 3];
                        case 'fullScreenMode': return [3 /*break*/, 4];
                        case 'toolAppearance': return [3 /*break*/, 12];
                    }
                    return [3 /*break*/, 13];
                case 1:
                    {
                        nextMode = displayMode === 'smartBoard' ? 'normal' : 'smartBoard';
                        setDisplayMode(nextMode);
                        modeName = t(nextMode === 'smartBoard' ? 'text.smartMode' : 'text.normalMode');
                        announce(t('text.displayModeChanged', { mode: modeName }));
                        return [3 /*break*/, 13];
                    }
                    _c.label = 2;
                case 2:
                    setContrast(contrast === 'normal' ? 'high' : 'normal');
                    return [3 /*break*/, 13];
                case 3:
                    customEventHandler.dispatchEvent('toggleKeyboardShortcuts', {});
                    return [3 /*break*/, 13];
                case 4:
                    target = !isFullScreen;
                    _c.label = 5;
                case 5:
                    _c.trys.push([5, 10, , 11]);
                    if (!target) return [3 /*break*/, 7];
                    return [4 /*yield*/, enterFullScreen()];
                case 6:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 7: return [4 /*yield*/, exitFullScreen()];
                case 8:
                    _c.sent();
                    _c.label = 9;
                case 9:
                    // The fullscreenchange listener (below) updates the store —
                    // we don't call setIsFullScreen here.
                    announce(t(target ? 'text.fullScreenEntered' : 'text.fullScreenExited'));
                    return [3 /*break*/, 11];
                case 10:
                    _b = _c.sent();
                    announce(t('text.fullScreenNotSupported'));
                    return [3 /*break*/, 11];
                case 11: return [3 /*break*/, 13];
                case 12:
                    {
                        z = subItem === 'small' ? 1 : subItem === 'medium' ? 1.5 : 2;
                        setplayerIconZoom(z);
                        return [3 /*break*/, 13];
                    }
                    _c.label = 13;
                case 13: return [2 /*return*/];
            }
        });
    }); };
    // Mirror `document.fullscreenElement` into the store so the menu label
    // re-renders when the user enters/exits fullscreen via Esc, F11, or any
    // other path. Listens to BOTH the standard event and the WebKit prefix.
    useEffect(function () {
        var sync = function () { return setIsFullScreen(getFullScreenElement() !== null); };
        sync(); // initial — covers reload-into-fullscreen
        document.addEventListener('fullscreenchange', sync);
        document.addEventListener('webkitfullscreenchange', sync);
        return function () {
            document.removeEventListener('fullscreenchange', sync);
            document.removeEventListener('webkitfullscreenchange', sync);
        };
    }, [setIsFullScreen]);
    var zoomOption = [t('text.small'), t('text.medium'), t('text.large')];
    useEffect(function () {
        document.documentElement.style.setProperty('--playerIcon-Zoom', String(playerIconZoom));
    }, [playerIconZoom]);
    useEffect(function () {
        if (btnRef.current) {
            var rect = btnRef.current.getBoundingClientRect();
            setPos({
                // left: btnRef.current.offsetLeft,
                left: 65 * playerIconZoom,
                bottom: window.innerHeight - rect.top + 30,
            });
        }
    }, [btnRef.current, playerIconZoom, gameLoaded]);
    return (_jsx("div", { className: "settingWithPopupContainer ", children: _jsx(CollapsibleDiv, { elements: settingsOptions, mainElement: {
                normal: './assets/images/icons/settingN.svg',
                hover: './assets/images/icons/settingH.svg',
                disable: './assets/images/icons/settingH.svg',
                active: './assets/images/icons/settingH.svg',
                activeHover: './assets/images/icons/settingH.svg',
                activeDisable: './assets/images/icons/settingH.svg',
                normaldark: './assets/images/icons/settingN.svg',
                hoverdark: './assets/images/icons/settingDH.svg',
                disabledark: './assets/images/icons/settingDH.svg',
                activedark: './assets/images/icons/settingDH.svg',
                activeHoverdark: './assets/images/icons/settingDH.svg',
            }, title: t('text.settings'), ariaLabel: "text.settings", showToolTip: true, mainEleNormalCSS: "settingsBtn", elemsDefaultCSS: "elemsDefaultCSS", onSelect: function (item, subItem) { return collapsibleSelectHandler(item, subItem); }, openAt: displayMode === 'smartBoard' ? 'top' : 'right', direction: displayMode === 'smartBoard' ? (playerIconZoom >= 1.5 ? 'topRight' : 'top') : 'right', isParentRelative: displayMode === 'smartBoard', isTooltipRelative: false, isInnerTooltipRelative: true, 
            // type='imageType1'
            innerBtnType: "imageType1", toogleTooltipDirection: displayMode === 'normal' ? 'top' : 'topRight', parentType: "settingWithPopup", addButtonToToggle: true }) }));
};
export default SettingWithPopup;
